<template>
  <div>
    PRocessando!
  </div>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'ContaAzulAuth',
  methods: {
    reloadPage() {
      opener.location.reload();
      window.close();
    },
    isAuthorized(value) {
      this.$store.commit('setContaAzulAuthorized', value);
    },
    checkAuthSuccess() {
      const url = `${baseApiUrl}/v1/contaazul/auth_contaazul?code=${this.$route.query.code}`;
      axios
        .get(url)
        .then((res) => {
          if (res.data.success) {
            this.isAuthorized(true);
            this.reloadPage();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.checkAuthSuccess();
  },
};
</script>

<style scoped></style>
